import React, { Component } from "react";
import axios from 'axios';
import dayjs from 'dayjs';
import { authService } from '../../services/authService';
import { theme, Row, Col, Card, Button, Input, Divider, Modal, Grid, Spin, Radio, DatePicker, TimePicker } from 'antd';
import { API_BASE_URL } from '../../config/api';

const { useBreakpoint } = Grid;

class PickupRequest extends Component {
  constructor(props) {
    super(props);
    const u = authService.getUserAttributes() || {};
    this.state = {
      errors: [],
      priority: 'Routine',
      address: props.client.Address || '',
      city: props.client.City || '',
      state: props.client.State || '',
      zip: props.client.Zip || '',
      pickupDate: null,
      pickupTime: null,
      contactName: `${u.family_name || ''} ${u.given_name || ''}`.trim() || u.name || '',
      phone: props.client.Telephone || '',
      email: u.email || '',
      comment: '',
      confirmationNumber: '',
      pickupID: 0,

      saving: false,
    };
  }

  handleChange = (field, value) => {
    this.setState({ [field]: value });
  }

  handleSubmit = async () => {
    this.setState({ errors: [], saving: true });
    const {
      priority, address, city, state, zip,
      pickupDate, pickupTime, contactName, phone, email, comment,
    } = this.state;

    let isValid = true;
    let errors = [];

    if (!address) {
      isValid = false;
      errors.push("Please enter pickup address");
    }
    if (!pickupDate) {
      isValid = false;
      errors.push("Please select pickup date");
    }
    if (!pickupTime) {
      isValid = false;
      errors.push("Please select pickup time");
    }
    if (!contactName) {
      isValid = false;
      errors.push("Please enter contact name");
    }
    if (!phone) {
      isValid = false;
      errors.push("Please enter phone number");
    }
    if (!email) {
      isValid = false;
      errors.push("Please enter email address");
    }

    let formData = {
      client: this.props.client,
      priority,
      address,
      city,
      state,
      zip,
      pickupDate: pickupDate ? pickupDate.format('YYYY-MM-DD') : '',
      pickupTime: pickupTime ? pickupTime.format('h:mm A') : '',
      contactName,
      phone,
      email,
      comment,
      username: this.props.client.ClientCode,
      prefix: 'PU',
    };

    if (isValid) {
      const token = await authService.ensureValidToken();
      if (!token) {
        console.error('Not authenticated');
        return;
      }

      axios({
        method: 'POST',
        url: `${API_BASE_URL}/connect/pickups/`,
        data: formData,
        headers: { Authorization: `Bearer ${token}` },
      }).then(res => {
        this.setState({
          pickupID: res.data.data.pickupId,
          confirmationNumber: res.data.data.confirmationNumber,
          saving: false,
        });
      }).catch(err => console.log(err));
    } else {
      this.setState({ errors, saving: false });
    }
  }

  handleOk = () => {
    const u = authService.getUserAttributes() || {};
    this.setState({
      errors: [],
      priority: 'Routine',
      address: this.props.client.Address || '',
      city: this.props.client.City || '',
      state: this.props.client.State || '',
      zip: this.props.client.Zip || '',
      pickupDate: null,
      pickupTime: null,
      contactName: `${u.family_name || ''} ${u.given_name || ''}`.trim() || u.name || '',
      phone: this.props.client.Telephone || '',
      email: u.email || '',
      comment: '',
      confirmationNumber: '',
      pickupID: 0,
    });
  }

  render() {
    const labelStyle = { fontWeight: 600, marginBottom: 4 };

    return (
      <Row>
        <Col span={24}>
          <Card
            title="Pickup Request"
            extra={
              <Button type="primary" onClick={this.handleSubmit}>
                {this.state.saving ? <Spin/> : <span>Submit Request</span>}
              </Button>
            }
          >
            <Row gutter={[8, 8]}>
              <Col xs={24} md={19}>
                {this.props.client?.id ?
                  <>
                    <strong>{this.props.client.ClientName}</strong> - {this.props.client.Address}, {this.props.client.City}, {this.props.client.State} {this.props.client.Zip}
                  </> : <></>
                }
              </Col>
              <Col xs={24} md={5}>
                {this.state.errors.length > 0 &&
                  <ul style={{ margin: 0, paddingLeft: 20 }}>
                    {this.state.errors.map((item, index) =>
                      <li style={{ color: 'red' }} key={index}>{item}</li>
                    )}
                  </ul>
                }
              </Col>
            </Row>

            <Divider />

            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div style={labelStyle}>Priority</div>
                <Radio.Group
                  value={this.state.priority}
                  onChange={(e) => this.handleChange('priority', e.target.value)}
                  buttonStyle="solid"
                >
                  <Radio.Button value="Routine">Routine</Radio.Button>
                  <Radio.Button
                    value="STAT"
                    style={this.state.priority === 'STAT' ?
                      { background: '#cc0000', borderColor: '#cc0000', color: '#fff' } : {}
                    }
                  >
                    STAT
                  </Radio.Button>
                </Radio.Group>
              </Col>

              <Col xs={24} md={10}>
                <div style={labelStyle}>Pickup Address</div>
                <Input
                  value={this.state.address}
                  onChange={(e) => this.handleChange('address', e.target.value)}
                />
              </Col>
              <Col xs={24} md={6}>
                <div style={labelStyle}>City</div>
                <Input
                  value={this.state.city}
                  onChange={(e) => this.handleChange('city', e.target.value)}
                />
              </Col>
              <Col xs={12} md={3}>
                <div style={labelStyle}>State</div>
                <Input
                  value={this.state.state}
                  onChange={(e) => this.handleChange('state', e.target.value)}
                />
              </Col>
              <Col xs={12} md={5}>
                <div style={labelStyle}>Zip</div>
                <Input
                  value={this.state.zip}
                  onChange={(e) => this.handleChange('zip', e.target.value)}
                />
              </Col>

              <Col xs={12} md={5}>
                <div style={labelStyle}>Pickup Date</div>
                <DatePicker
                  value={this.state.pickupDate}
                  onChange={(date) => this.handleChange('pickupDate', date)}
                  disabledDate={(d) => d && d < dayjs().startOf('day')}
                  format="MM/DD/YYYY"
                  style={{ width: '100%' }}
                />
              </Col>
              <Col xs={12} md={5}>
                <div style={labelStyle}>Pickup Time</div>
                <TimePicker
                  value={this.state.pickupTime}
                  onChange={(time) => this.handleChange('pickupTime', time)}
                  format="h:mm A"
                  minuteStep={15}
                  use12Hours
                  style={{ width: '100%' }}
                />
              </Col>
              <Col xs={24} md={14}></Col>

              <Col xs={24} md={8}>
                <div style={labelStyle}>Contact Name</div>
                <Input
                  value={this.state.contactName}
                  onChange={(e) => this.handleChange('contactName', e.target.value)}
                />
              </Col>
              <Col xs={24} md={8}>
                <div style={labelStyle}>Phone Number</div>
                <Input
                  value={this.state.phone}
                  onChange={(e) => this.handleChange('phone', e.target.value)}
                />
              </Col>
              <Col xs={24} md={8}>
                <div style={labelStyle}>Email Address</div>
                <Input
                  value={this.state.email}
                  onChange={(e) => this.handleChange('email', e.target.value)}
                />
              </Col>

              <Col span={24}>
                <Input.TextArea
                  placeholder="Add a comment..."
                  value={this.state.comment}
                  onChange={(e) => this.handleChange('comment', e.target.value)}
                  rows={4}
                />
              </Col>
            </Row>
          </Card>

          {this.state.pickupID ?
            <Modal
              title="Pickup Request Confirmation"
              closable={{ 'aria-label': 'Custom Close Button' }}
              open={!!this.state.pickupID}
              onOk={this.handleOk}
              onCancel={this.handleOk}
            >
              <div style={{ textAlign: 'center', padding: '24px 0' }}>
                <span style={{ color: '#cc0000', fontSize: 28, fontWeight: 700 }}>
                  {this.state.confirmationNumber}
                </span>
              </div>
            </Modal> : <></>
          }
        </Col>
      </Row>
    );
  }
}

export default function PickupRequestWrapper(props) {
  const { token } = theme.useToken();
  const screens = useBreakpoint();
  return <PickupRequest {...props} token={token} screens={screens} />;
}
